export const en = {
  'generator-title-apa6' : 'Free APA 6 Citation Generator',
  'generator-title-apa7' : 'Free APA 7 Citation Generator',
  'generator-title-mla7' : 'Free MLA 7 Citation Generator',
  'generator-title-mla8' : 'Free MLA 8 Citation Generator',
  'generator-title-chicago' : 'Free Chicago Citation Generator & Guide',
  'generator-title-vancouver' : 'Free Vancouver Citation Generator & Guide',
  'generator-description-apa6' : 'Generate FREE APA 6th and 7th edition citations. Books, journals, and online sources. Copy citations directly to your reference list. Easy to use and ad-free!',
  'generator-description-apa7' : 'Generate FREE APA 6th and 7th edition citations. Books, journals, and online sources. Copy citations directly to your reference list. Easy to use and ad-free!',
  'generator-description-mla7' : 'Generate FREE MLA 7th and 8th edition citations. Books, journals, and online sources. Copy citations directly to your Works Cited. Easy to use and ad-free!',
  'generator-description-mla8' : 'Generate FREE MLA 7th and 8th edition citations. Books, journals, and online sources. Copy citations directly to your Works Cited. Easy to use and ad-free!',
  'generator-description-chicago' : 'Generate FREE Chicago Manual of Style (17th edition) citations. Books, journals, and online sources. Copy citations directly to your reference list.',
  'generator-description-vancouver' : 'Generate FREE Vancouver Style citations. Books, journals, and online sources. Copy citations directly to your reference list. Easy to use!',
  'Brand Name' : 'Wordvice',
  'Citation Generator' : 'Citation Generator',
  'Contributors': 'Contributors',
  'Page Name' : 'Page Title',
  'Site Name' : 'Site Name',
  'Date Published' : 'Date Published',
  'Date Accessed' : 'Date Accessed',
  'Publisher' : 'Publisher',
  'Publisher Name' : 'Publisher Name',
  'Publication Info' : 'Publication Info',
  'Publication Location' : 'Publication Location',
  'Publication Year' : 'Publication Year',
  'Day' : 'Day',
  'Month' : 'Month',
  'Year' : 'Year',
  'Generate' : 'Generate',
  'button_generate' : 'Generate',
  'Copied.' : 'Copied.',
  'copied_messgage' : 'Successfully copied.',
  'generate_result' : 'Citation result.',
  'Article Title' : 'Article Title',
  'Journal Title' : 'Journal Title',
  'Edition' : 'Edition',
  'Volume' : 'Volume',
  'Issue' : 'Issue',
  'Number' : 'Number',
  'Pages' : 'Pages',
  'Website or Database Title' : 'Website or Database Title',
  'Title' : 'Title',
  'Location' : 'Location',
  'cite-Source' : 'Source',
  'cite-Style' : 'Style',
  'Copy' : 'Copy',
  'Delete' : 'Delete',
  'Number or name' : 'Number or name',
  'source-Website' : 'Website',
  'source-Journal Article' : 'Journal Article',
  'source-Book' : 'Book',
  'site_desc' : 'Select a style guide and enter the source information to generate a citation.',
  'Example' : 'Example',
  'Format' : 'Format',
  'Citation Style Guides' : 'Citation Style Guides',

  'Page Title' : 'Page Title',
  'Author Last Name' : 'Author Last Name',
  'Author First Name' : 'Author First Name',
  'Author First Initial' : 'Author First Initial',
  'Author Middle Name' : 'Author Middle Name',
  'Author Middle Initial' : 'Author Middle Initial',
  'Website Name' : 'Website Name',
  'Print' : 'Print',
  'Digital' : 'Digital',
  'Published Year' : 'Published Year',
  'Published Date' : 'Published Date',

  'citation-desc' : "Select a style guide and enter all relevant information about your source. Then click \“Generate\” to generate a cited reference. Your citations will appear at the bottom of the citation generator. You can copy your citation to your References page or delete it from the list.",
  'author' : 'Author',
  'editor' : 'Editor',
  'translator' : 'Translator',
  'First Name' : 'First Name',
  'Middle' : 'Middle',
  'Last Name' : 'Last Name',
  'Quick Guides' : 'Quick Guides',
  'APA Citation Guide' : 'APA Citation Guide',
  'MLA Citation Guide' : 'MLA Citation Guide',
  'Chicago Citation Guide' : 'Chicago Citation Guide',
  'Vancouver Citation Guide' : 'Vancouver Citation Guide',
  'Style Guide Introduction' : 'Style Guide Introduction',

  "apa" : {
    "page-title" : "APA Citation Generator",
    "page-description" : "APA Style is commonly used by researchers and students in the social sciences, behavioral sciences, business, and nursing. Our free APA citation generator automatically generates references and in-text citations for APA 6 and APA 7 styles. Read the APA citation guidelines at the bottom of the page for specific APA in-text citation and reference rules.",
    "meta-title" : "APA Style Citation & Reference Generator",
    "meta-description" : "Generate FREE APA 6th and 7th edition citations & references. Books, journals, and online sources. Copy citations directly to your reference list.",
  },

  "mla" : {
    "page-title" : "MLA Citation Generator",
    "page-description" : "MLA Style is commonly used by authors and students preparing manuscripts and research papers for humanities disciplines such as cultural studies, English, literature, and critical theory. Our free MLA Citation Generator automatically generates references and citations for MLA 7 and MLA 8 styles. Read the MLA citation guidelines at the bottom of the page for specific MLA in-text citation and reference rules.",
    "meta-title" : "MLA Style Citation & Reference Generator",
    "meta-description" : "Generate FREE MLA 7th and 8th edition citations & references. Books, journals, and online sources. Copy citations directly to your Works Cited. Easy to use and ad-free!",
  },

  "chicago" : {
    "page-title" : "Chicago Citation Generator",
    "page-description" : "Chicago Style (or Chicago Manual of Style) is primarily used for academic papers in the arts, humanities, and social sciences. Our free Chicago Style Citation Generator automatically generates references and citations for Chicago 17th–the most recent Chicago Style edition. Read the Chicago Style citation guidelines at the bottom of the page for specific Chicago in-text citation and reference rules.",
    "meta-title" : "Chicago Style Citation & Reference Generator",
    "meta-description" : "Create FREE Chicago Manual of Style (17th edition) references & citations. Books, journals, and online sources. Copy citations directly to your reference list.",
  },

  "vancouver" : {
    "page-title" : "Vancouver Citation Generator",
    "page-description" : "Vancouver Style is used by hundreds of scientific journals, including IEEE and MEDLINE. Scientific journals have their own author guidelines when it comes to references. Vancouver encompasses any author-number system regardless of formatting specifics. Read the Vancouver Style citation guidelines at the bottom of the page for specific Vancouver citation rules.",
    "meta-title" : "Vancouver Style Citation & Reference Generator",
    "meta-description" : "Generate FREE Vancouver Style citations and references. Books, journals, and online sources. Copy citations directly to your reference list.",
  },

  // sidebar
  "Citation Sources" : "Citation Sources",
  "citation_sources" : {
    "link1" : {
      "uri" : "https://blog.wordvice.com/youtube-video-citation-apa-mla-chicago-vancouver/",
      "title" : "How to Cite a YouTube Video",
    },
    "link2" : {
      "uri" : "https://blog.wordvice.com/how-to-cite-images-apa-mla-chicago-vancouver/",
      "title" : "How to Cite an Image",
    },
    "link3" : {
      "uri" : "https://blog.wordvice.com/how-to-cite-movie-apa-mla-chicago-vancouver/",
      "title" : "How to Cite a Movie",
    },
    "link4" : {
        "uri" : "https://blog.wordvice.com/how-to-cite-a-website-apa-mla-chicago-vancouver/",
        "title" : "How to Cite a Website"
    },
    "link5" : {
        "uri" : "https://blog.wordvice.com/how-to-cite-a-podcast-apa-mla-chicago-vancouver/",
        "title" : "How to Cite a Podcast"
    },
    "link6" : {
        "uri" : "https://blog.wordvice.com/how-to-cite-chatgpt-sources-apa-mla-chicago-vancouver/",
        "title" : "How to Cite ChatGPT"
    },
    "link7" : {
        "uri" : "https://blog.wordvice.com/how-to-cite-a-book-apa-mla-chicago-vancouver-style/",
        "title" : "How to Cite a Book"
    },
  }
};



// WEBPACK FOOTER //
// ./src/lang/en.js